import React from "react";

import SkeletonBox from "components/Custom/SkeletonBox";

const OrderSkeleton = (props: any) => {
  const gridHeight = window.innerHeight * 0.5;

  return (
    <div
      className="flexColumn"
      style={{ height: gridHeight, marginTop: 10, width: "98%" }}
    >
      <div
        className="flexRow"
        style={{
          justifyContent: "space-between",
          width: "98%",
        }}
      >
        <div className="flexRow" style={{ width: "50%" }}>
          <SkeletonBox
            height={30}
            width={"18%"}
            style={{ marginBottom: 5, marginRight: "1rem", borderRadius: 5 }}
          />
          <SkeletonBox
            height={30}
            width={"18%"}
            style={{ marginBottom: 5, marginRight: "1rem", borderRadius: 5 }}
          />
          <SkeletonBox
            height={30}
            width={"18%"}
            style={{ marginBottom: 5, marginRight: "1rem", borderRadius: 5 }}
          />
          <SkeletonBox
            height={30}
            width={"18%"}
            style={{ marginBottom: 5, marginRight: "1rem", borderRadius: 5 }}
          />
          <SkeletonBox
            height={30}
            width={"18%"}
            style={{ marginBottom: 5, marginRight: "1rem", borderRadius: 5 }}
          />
          <SkeletonBox
            height={30}
            width={"18%"}
            style={{ marginBottom: 5, marginRight: "1rem", borderRadius: 5 }}
          />
        </div>
        <div
          className="flexRow"
          style={{
            width: "25%",
            justifyContent: "flex-end",
          }}
        >
          <SkeletonBox
            height={30}
            width={"30%"}
            style={{ marginBottom: 5, marginRight: 10, borderRadius: 5 }}
          />

          <SkeletonBox
            height={30}
            width={"30%"}
            style={{ marginBottom: 5, borderRadius: 5 }}
          />
        </div>
      </div>

      <SkeletonBox height={gridHeight - 50} width={"98%"} />
    </div>
  );
};

export default OrderSkeleton;
